import React from 'react';
import classNames from 'classnames';

const FilterButton = ({ label, onClick, isActive, className }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames('transition-all duration-200 text-sm font-semibold rounded-lg px-4 py-2', className)}
      style={
        isActive
          ? {
              background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
              color: '#fff',
              boxShadow: '0 2px 10px rgba(99,102,241,0.4)',
              border: '1px solid transparent',
            }
          : {
              background: 'rgba(255,255,255,0.04)',
              color: '#64748b',
              border: '1px solid rgba(255,255,255,0.08)',
            }
      }
      onMouseEnter={e => {
        if (!isActive) {
          (e.currentTarget as HTMLElement).style.background = 'rgba(99,102,241,0.12)';
          (e.currentTarget as HTMLElement).style.color = '#a5b4fc';
          (e.currentTarget as HTMLElement).style.borderColor = 'rgba(99,102,241,0.3)';
        }
      }}
      onMouseLeave={e => {
        if (!isActive) {
          (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.04)';
          (e.currentTarget as HTMLElement).style.color = '#64748b';
          (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.08)';
        }
      }}
    >
      {label}
    </button>
  );
};

export default FilterButton;
